import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapMowerHouseExecutionTargets = (update: Update) => [
  {
    hfsActionId: HfsSettingsActionEnum.MOWER_HOUSE_ENABLED,
    iprId: update.assetId,
    payload: {
      installed: update.enabled,
    },
  },
];
